<template>
  <div v-loading="loading">
    <div v-if="loadingTemplate" class="well well-small">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <MessagesSection :snapshot="snapshot" :detail="detail" />
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <CouponsSection :snapshot="snapshot" :detail="couponDetail" />
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <DeliverySection :snapshot="snapshot" :detail="deliveryDetail" />
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <AlertsSection :snapshot="snapshot" :detail="detail" />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <DeliveryDetailSection
            :tabName="tabName"
            :bar15Days="bar15Days"
            :bar6Months="bar6Months"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <OpenRateRankingSection
            :openRatioBar="openRatioBar"
            :openQtyBar="openQtyBar"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <RedemptionRateRankingSection
            :redemptionRatioBar="redemptionRatioBar"
            :redemptionQtyBar="redemptionQtyBar"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <RFMMapv2Section :rfmMap="snapshot.rfmMap" />

        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <RFMSection :rfmMap="snapshot.rfmMap" :pieChart="rfmPieChart" />
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="end">
        <div style="padding-right: 10px;">
          <span
            >{{ i18nValues["lastUpdate"] }}
            {{ snapshot.snapshotDatetime | format }}</span
          >
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import moment from "moment";
import MessagesSection from "@/components/dashboard/sections/MessagesSection.vue";
import CouponsSection from "@/components/dashboard/sections/CouponsSection.vue";
import DeliverySection from "@/components/dashboard/sections/DeliverySection.vue";
import AlertsSection from "@/components/dashboard/sections/AlertsSection.vue";
import DeliveryDetailSection from "@/components/dashboard/sections/DeliveryDetailSection.vue";
import OpenRateRankingSection from "@/components/dashboard/sections/OpenRateRankingSection.vue";
import RedemptionRateRankingSection from "@/components/dashboard/sections/RedemptionRateRankingSection.vue";
import RFMMapv2Section from "@/components/dashboard/sections/RFMMapv2Section.vue";
import RFMSection from "@/components/dashboard/sections/RFMSection.vue";

export default {
  name: "DMDashboard",
  created: function() {
    this.buildDash();
  },
  watch: {
    $route: function() {
      this.buildDash();
    },
  },
  components: {
    MessagesSection,
    CouponsSection,
    DeliverySection,
    AlertsSection,
    DeliveryDetailSection,
    OpenRateRankingSection,
    RedemptionRateRankingSection,
    RFMSection,
    RFMMapv2Section
  },
  props: {},
  computed: {
    loadingDash: get("dashboard/loadingSnapshot"),
  },
  data() {
    return {
      fullscreenLoading: null,
      detail: [],
      couponDetail: [],
      deliveryDetail: [],
      loading: true,
      loadingTemplate: false,
      snapshot: { activePromotions: 0 },
      pieChart: null,
      bar15Days: { labels: [], datasets: [] },
      bar6Months: { labels: [], datasets: [] },
      tabName: "last15Days",
      rfmMapDetail: [],
      rfmMapNames: [],
      rfmPieChart: [],
    };
  },
  methods: {
    buildDash() {
      this.$store
        .dispatch("dashboard/retrieveDMSnapshot")
        .then((response) => {
          this.snapshot = response;
          if (this.snapshot) {
            this.buildCharts();
          }
          this.loading = this.loadingThreshold;
        })
        .catch(() => {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["errorSnapshot"],
            position: "bottom-right",
            duration: 7000,
          });
        });
    },
    buildCharts() {
      //Messages
      this.detail = this.detail.concat({
        cant: this.snapshot.currentMessages,
        type: this.i18nValues["current"],
      });
      this.detail = this.detail.concat({
        cant: this.snapshot.totalMessages,
        type: this.i18nValues["total"],
      });
      this.detail = this.detail.concat({
        cant: this.snapshot.unconfirmedMessages,
        type: this.i18nValues["unconfirmedMessages"],
      });

      //Coupon
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentCouponMessages,
        type: this.i18nValues["coupons"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentTargetedMessages,
        type: this.i18nValues["targeted"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentMsgMessages,
        type: this.i18nValues["currentMessages"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentGCMessages,
        type: this.i18nValues["currentGCMessages"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentSTMessages,
        type: this.i18nValues["smart_targeting"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentLTCMessages,
        type: this.i18nValues["currentLTCMessages"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentBirthdayMessages,
        type: this.i18nValues["currentBirthdayMessages"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentSelectionOfferMessages,
        type: this.i18nValues["tenders"],
      });
      this.couponDetail = this.couponDetail.concat({
        cant: this.snapshot.currentMassiveMessages,
        type: this.i18nValues["massive"],
      });

      //Delivery
      this.deliveryDetail = this.deliveryDetail.concat({
        cant: this.snapshot.totalSentMessages,
        type: this.i18nValues["totalSentMessages"],
      });
      this.deliveryDetail = this.deliveryDetail.concat({
        cant: this.snapshot.totalPendingMessages,
        type: this.i18nValues["pending"],
      });
      this.deliveryDetail = this.deliveryDetail.concat({
        cant: this.snapshot.totalInProcessMessages,
        type: this.i18nValues["sm_processing"],
      });
      this.deliveryDetail = this.deliveryDetail.concat({
        cant: this.snapshot.deliveryRatio,
        type: this.i18nValues["delivery_ratio"],
      });

      //DeliveryDetail
      let labelForecast15Days = [];
      let dataForecast15Days = [];
      let labelForecast6Months = [];
      let dataForecast6Months = [];

      for (let i = 0; i < this.snapshot.deliveryDetail.length; i++) {
        if (this.snapshot.deliveryDetail[i].day) {
          labelForecast15Days = labelForecast15Days.concat(
            this.snapshot.deliveryDetail[i].day
          );
          dataForecast15Days = dataForecast15Days.concat(
            this.snapshot.deliveryDetail[i].deliveryQty
          );
        } else {
          labelForecast6Months = labelForecast6Months.concat(
            this.snapshot.deliveryDetail[i].month
          );
          dataForecast6Months = dataForecast6Months.concat(
            this.snapshot.deliveryDetail[i].deliveryQty
          );
        }
      }
      this.bar15Days = {
        labels: labelForecast15Days,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataForecast15Days,
          },
        ],
      };
      this.bar6Months = {
        labels: labelForecast6Months,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataForecast6Months,
          },
        ],
      };

      //RankingOpenRate
      let labelOpenRatio = [];
      let dataOpenRatio = [];
      let labelOpenQty = [];
      let dataOpenQty = [];

      labelOpenRatio = this.snapshot.feedback.map((a) => a.message);
      dataOpenRatio = this.snapshot.feedback.map((a) => a.openingRatio);

      labelOpenQty = this.snapshot.feedback.map((a) => a.message);
      dataOpenQty = this.snapshot.feedback.map((a) => a.openedQty);

      this.openRatioBar = {
        labels: labelOpenRatio,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataOpenRatio,
          },
        ],
      };
      this.openQtyBar = {
        labels: labelOpenQty,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataOpenQty,
          },
        ],
      };

      //RankingRedemptionRate
      let labelRedemptionRatio = [];
      let dataRedemptionRatio = [];
      let labelRedemptionQty = [];
      let dataRedemptionQty = [];

      labelRedemptionRatio = this.snapshot.feedback.map((a) => a.message);
      dataRedemptionRatio = this.snapshot.feedback.map(
        (a) => a.redemptionRatio
      );

      labelRedemptionQty = this.snapshot.feedback.map((a) => a.message);
      dataRedemptionQty = this.snapshot.feedback.map((a) => a.redemptionQty);

      this.redemptionRatioBar = {
        labels: labelRedemptionRatio,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataRedemptionRatio,
          },
        ],
      };
      this.redemptionQtyBar = {
        labels: labelRedemptionQty,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            data: dataRedemptionQty,
          },
        ],
      };

      //RFMMap
      for (let i = 0; i < this.snapshot.rfmMap.length; i++) {
        let rfmMapFormatted = [];
        this.rfmMapNames = this.rfmMapNames.concat(
          this.snapshot.rfmMap[i].rfmSegment
        );
        rfmMapFormatted = rfmMapFormatted.concat({
          cant: this.snapshot.rfmMap[i].customersQty,
          type: this.i18nValues["customersQty"],
        });
        rfmMapFormatted = rfmMapFormatted.concat({
          cant: this.snapshot.rfmMap[i].percentOfTotalCustomers,
          type: this.i18nValues["percentOfTotalCustomers"],
        });
        rfmMapFormatted = rfmMapFormatted.concat({
          cant: this.snapshot.rfmMap[i].averageRecency,
          type: this.i18nValues["averageRecency"],
        });
        rfmMapFormatted = rfmMapFormatted.concat({
          cant: this.snapshot.rfmMap[i].averageFrequency,
          type: this.i18nValues["averageFrequency"],
        });
        rfmMapFormatted = rfmMapFormatted.concat({
          cant: this.snapshot.rfmMap[i].averageMonetaryValue,
          type: this.i18nValues["averageMonetaryValue"],
        });
        this.rfmMapDetail.push(rfmMapFormatted);
      }

      // RFMPieChart
      let series = [];
      series = this.snapshot.rfmMap.map((a) => a.customerQty),
      this.rfmPieChart = {
          series,
          labels: this.snapshot.rfmMap.map((a) => a.rfmSegment),
      };

      this.loadingTemplate = true;
    },
    formatTableDate(row) {
      return this.formatDate(row.lastDelivery);
    },
  },
  filters: {
    format(val) {
      let auxDate = moment(val, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    },
  },
};
</script>
